/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { PageVersionTypeEnums } from '@/views_v2/new-redirect/types';
import { Component, Vue } from 'vue-property-decorator';
import { HistoryManager } from '@/shared/historyManager';
import { marketingBackId } from '@/components/adv-components/adv-marketing-back-popup';

@Component
export default class MarketingLeaving extends Vue {
    protected showLeavingPop = false;

    /** 是否命中ab */
    protected isHintAb = false;

    /** 展示当前挽留弹窗 */
    protected beforeLeave():void {
      if (this.isHintAb) {
        this.showLeavingPop = true;
        // 曝光埋点
        this.$ubtModuleExpose('finance_smsMarketing_landingPage_backPopup');
      }
    }

    /** 获取ab结果 */
    protected async getPopAbRes():Promise<void> {
      try {
        this.isHintAb = await Vue.prototype.$tangram.getAbTestResult({
          moduleCode: 'financial',
          keyCode: 'FinanceH5.LandingPageWithLeaving',
        });
      } catch {
        this.isHintAb = false;
      }
    }

    /** 通过ab来判断是否展示挽留弹窗 */
    protected async getLeavingShow():Promise<void> {
      // 只有006、008版本做挽留弹窗逻辑
      const { type } = this.$route.query;
      if (type === PageVersionTypeEnums.BRANDVERSIONWITHLOGINANDINFO_WITHOUT_ANDROIDJUMP
            || type === PageVersionTypeEnums.BRAND_VERSION_WITHLOGIN_AND_INFO) {
        try {
          await this.getPopAbRes();
          if (this.isHintAb) {
            // 解决如果没有配置任务，回退需要两次
            HistoryManager.leavingPush(marketingBackId, true);
          }
        } catch {
          this.isHintAb = false;
        }
      }
    }
}
